.flags{
  @media (min-width: 767px) {
    overflow: auto;
  }
  @media (max-width: 767px) {
    height: auto !important;
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/flags/flags.scss